<template>
    <div class="mt-3 flex items-center justify-between">
        <div class="text-gray-800">
            <i18n-t
                keypath="giftCardWithToken"
                tag="span"
            >
                <template #token>
                    <span class="text-gray-600">{{ giftCard.token }}</span>
                </template>
            </i18n-t>
        </div>
        <span class="text-gray-800">
            {{ amountFormatted }}
        </span>
    </div>
</template>

<script setup lang="ts">
import type { GiftCardPaymentInfo } from '~/components/Checkout/Sections/PaymentInformation.vue'
import { computed } from 'vue'
import { Decimal } from '~/composables/support/decimal'
import { I18nT, useI18n } from 'vue-i18n'

const props = defineProps<{
    giftCard: GiftCardPaymentInfo
}>()

useI18n({ useScope: 'global' })

const amountFormatted = computed(() => {
    // Gift card amounts reduce the balance due, so render them as a negative value.
    return new Decimal(props.giftCard.amount)
        .invertSign()
        .formatCurrency(2, false)
})
</script>
